import axios from 'axios'
import { NavigateFunction } from 'react-router/dist/lib/hooks'
import { tokens } from 'locales/tokens';

export const getAxios = (baseURL: string | undefined, $alert: Function, navigate: NavigateFunction, t: Function, setBlocked: Function) => {
    //create an axios instance
    const axiosInstance = axios.create({
        baseURL,
        headers: {
            "Accept-Language": localStorage.getItem("i18nextLng"),
        },
    })

    //요청 타임아웃 설정
    // axiosInstance.defaults.timeout = 5000
    axiosInstance.defaults.withCredentials = true

    //요청 인터셉터 추가
    axiosInstance.interceptors.request.use(
        (config) => {
            setBlocked(true)
            config.headers.Authorization = localStorage.getItem('rdmsToken')
            return config
        },
        (error) => {
            console.log(error) //디버깅
            setBlocked(false)
            return Promise.reject(error)
        },
    )

    //응답 인터셉터 추가
    axiosInstance.interceptors.response.use(
        async (response) => {
            const contentType = response.headers['content-type']

            const res = response.data

            if (contentType === 'application/octet-stream') {
                const href = URL.createObjectURL(new Blob([res], { type: 'application/octet-stream' }))

                // create "a" HTML element with href to file & click
                const link = document.createElement('a')
                link.href = href
                link.setAttribute('download', decodeURI(response.headers['timf-file-name']))
                document.body.appendChild(link)
                link.click()

                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link)
                URL.revokeObjectURL(href)
                setBlocked(false)
                return
            }

            setBlocked(false)

            const { isSuccess, error, data } = res

            if (response.status === 204) {
                return response.status
            }

            if (isSuccess) {
                return data
            } else {
                await $alert({
                    title: t(tokens.common.fail),
                    text: error,
                    icon: 'error',
                })
                return null
            }
        },

        async (error) => {
            setBlocked(false)
            const { response, config, code } = error

            if (!response && code === 'ERR_NETWORK') {
                await $alert({
                    title: t(tokens.common.network_error),
                    text: t(tokens.common.cannot_connect_server),
                    icon: 'error',
                })
                return
            }

            const { status, data } = response

            switch (status) {
                case 401:
                    localStorage.setItem('rdmsToken', `Bearer ${data.token}`)
                    return axiosInstance(config)
                case 403:
                    localStorage.setItem('rdmsToken', '')
                    navigate('/login')
                    return
                default:
                    return Promise.reject(error)
            }
        },
    )

    return axiosInstance
}

export const download = async (baseURL: string | undefined, uri: string, fileNm: string) => {
    if (!baseURL) {
        return
    }

    const axiosInstance = axios.create({
        baseURL,
    })

    axiosInstance.defaults.withCredentials = true

    const response = await axios.get(`${baseURL}${uri}`, {
        responseType: 'blob',
    })

    const href = URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.href = href
    document.body.appendChild(link)
    link.setAttribute('download', decodeURI(fileNm ? fileNm : 'download'))
    link.click()

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link)
    URL.revokeObjectURL(href)
}
